/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_No_Members_TextInputs */



/**
* | output |
* | --- |
* | "Add people one at a time or import a CSV file." |
*
* @param {Team_Manager_No_Members_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_no_members_text = /** @type {((inputs?: Team_Manager_No_Members_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_No_Members_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajoutez des personnes une à une ou importez un fichier CSV.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fügen Sie Personen einzeln hinzu oder importieren Sie eine CSV-Datei.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi persone una alla volta o importa un file CSV.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавляйте людей по одному или импортируйте CSV-файл.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añade personas de una en una o importa un archivo CSV.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("逐个添加成员，或导入 CSV 文件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1 人ずつ追加するか、CSV ファイルを読み込んでください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लोगों को एक-एक करके जोड़ें या CSV फ़ाइल इंपोर्ट करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicione pessoas uma a uma ou importe um ficheiro CSV.")
	return /** @type {LocalizedString} */ ("Add people one at a time or import a CSV file.")
});